module.exports = __webpack_public_path__ + "img/12-find-in-tree.611b6842.png";